/**
 * Generated runtime TestId mirror for frontend/src/pages/RestrictionRuleRequestDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const RestrictionRuleRequestDetailTestIds = {
  approvalChainCard: "approval-chain-card",
  approvalChainEmpty: "approval-chain-empty",
  btnCancelRequest: "btn-cancel-request",
  btnDelete: "btn-delete",
  btnEdit: "btn-edit",
  btnRunTest: "btn-run-test",
  btnSubmitForApproval: "btn-submit-for-approval",
  cardLinkedRule: "card-linked-rule",
  cardProposedConfig: "card-proposed-config",
  cardRequestInfo: "card-request-info",
  cardTestPanel: "card-test-panel",
  cardTitleApprovalChain: "card-title-approval-chain",
  cardTitleLinkedRule: "card-title-linked-rule",
  cardTitleProposedConfig: "card-title-proposed-config",
  cardTitleTestPanel: "card-title-test-panel",
  colProfileName: "col-profile-name",
  errorRejectComment: "error-reject-comment",
  linkLinkedRule: "link-linked-rule",
  linkOwnerParty: "link-owner-party",
  linkedRuleEmpty: "linked-rule-empty",
  requestTypeBadge: "request-type-badge",
  restrictionRuleRequestDetailPage: "restriction-rule-request-detail-page",
  textareaApproveComment: "textarea-approve-comment",
  textareaRejectComment: "textarea-reject-comment",
  escalationTimeline: (step_id: string) => `escalation-timeline-${step_id}`,
  escalationTimelinePrefix: () => "escalation-timeline-" as TestIdPrefix,
  linkProfile: (profile_id: string) => `link-profile-${profile_id}`,
  linkProfilePrefix: () => "link-profile-" as TestIdPrefix,
  statusBadge: (request_status: string) => `status-badge-${request_status}`,
  statusBadgePrefix: () => "status-badge-" as TestIdPrefix
} as const;
